import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { useLang } from '../i18n';
import Seo from '../components/Seo';
import { Brush } from '../components/Brush';

const TESTI = {
  it: {
    title: 'Accessibilità',
    description:
      'Accessibilità del sito VdE Tivoli 1996, vetrina e catalogo di Galileo S.p.A., e del percorso di acquisto su satur.it.',
  },
  en: {
    title: 'Accessibility',
    description:
      'Accessibility of the VdE Tivoli 1996 website, the showcase and catalogue of Galileo S.p.A., and of the purchase path on satur.it.',
  },
};

export default function Accessibilita() {
  const { lang } = useLang();
  const tx = TESTI[lang] || TESTI.it;
  const [sections, setSections] = useState([]);

  useEffect(() => {
    api.get('/accessibilita', { params: { lang } }).then((r) => setSections(r.data));
  }, [lang]);

  return (
    <>
      <Seo title={tx.title} description={tx.description} path="/accessibilita" />

      <header className="py-14 md:py-20">
        <div className="wrap">
          <h1 className="relative inline-block">
            <span className="display-xl">{tx.title}</span>
            <Brush className="absolute -bottom-1 left-0 h-[0.34em] w-full" opacity={0.32} />
          </h1>
        </div>
      </header>

      <section className="py-14 md:py-20">
        <div className="wrap max-w-3xl">
          {sections.map((s, i) => (
            <article key={s.title || i} className="py-8 first:pt-0">
              {s.title && <h2 className="font-display text-2xl md:text-3xl">{s.title}</h2>}
              <div
                className="prosa mt-4 space-y-4 [&_a]:underline [&_a]:decoration-1 [&_a]:underline-offset-2"
                dangerouslySetInnerHTML={{ __html: s.html }}
              />
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
